import type { FC } from "react";
import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormDescription,
} from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import type { Control } from "react-hook-form";

// フォームの値の型を定義
interface NotificationFormValues {
	[key: string]: boolean;
}

interface NotificationToggleProps {
	name: string;
	title: string;
	description: string;
	control: Control<NotificationFormValues>;
}

export const NotificationToggle: FC<NotificationToggleProps> = ({
	name,
	title,
	description,
	control,
}) => {
	return (
		<FormField
			control={control}
			name={name}
			render={({ field }) => (
				<FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
					<div className="space-y-0.5">
						<FormLabel className="text-base">{title}</FormLabel>
						<FormDescription>{description}</FormDescription>
					</div>
					<FormControl>
						<Switch checked={field.value} onCheckedChange={field.onChange} />
					</FormControl>
				</FormItem>
			)}
		/>
	);
};
